"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _InputSerialization_1 = require("./_InputSerialization");
var _OutputSerialization_1 = require("./_OutputSerialization");
exports._SelectParameters = {
    type: "structure",
    required: [
        "InputSerialization",
        "ExpressionType",
        "Expression",
        "OutputSerialization"
    ],
    members: {
        InputSerialization: {
            shape: _InputSerialization_1._InputSerialization
        },
        ExpressionType: {
            shape: {
                type: "string"
            }
        },
        Expression: {
            shape: {
                type: "string"
            }
        },
        OutputSerialization: {
            shape: _OutputSerialization_1._OutputSerialization
        }
    }
};
//# sourceMappingURL=_SelectParameters.js.map